// What the tab keeps for the person signed in, besides the sign-in itself: their uploads, the
// send and checkout markers, the trip to the paywall, and a signup started here and not
// verified (its email code's session). Forgotten whenever the tab's person changes (Log out,
// step 1's "Continue as", the login's hand-off), together with step 4's state, which the caller
// resets. The sign-in stays: Continue as and the hand-off have just made it.

import { forgetSignupSession } from "../../../models/submissionSignupModel";

export const PERSONAL_KEYS = ["sfPmUploads.v1", "sfSendRequestId.v1", "sfCheckoutSession.v1", "sfLeftForPaywall.v1"];

export const forgetTabAccount = () => {
  PERSONAL_KEYS.forEach((key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  });
  // Restored by the code screen once the sign-in has ended, as the previous visitor's.
  forgetSignupSession();
};
